module.exports = __webpack_public_path__ + "static/media/female-red-v3.aab153fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/female-red-v3.svg
// module id = 72
// module chunks = 0